/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInlineMessageRequest} from '@cash-web/protos/squareup/cash/cashlimitsxp/api/v1/inline_message.pb'
import {GetInlineMessageResponse} from '@cash-web/protos/squareup/cash/cashlimitsxp/api/v1/inline_message.pb'


export const getInlineMessage = (request: GetInlineMessageRequest, options?: CashRequestOptions) => post<GetInlineMessageRequest, GetInlineMessageResponse>("/2.0/cash/get-inline-message", request, {...options, rejectOnError: true })